import { FC, useState } from 'react';
import { useTranslate } from 'hooks/useTranslate';

import InputText from 'modules/_shared/components/InputText';
import { MessageType } from 'modules/_shared/components/InputMessage';
import Button from 'modules/_shared/components/Buttons';
import { useSendCommunicationModal } from '../context/SendCommunicationModalContext';

const TestEmailSection: FC = () => {
  const { t } = useTranslate();
  const { data, actions } = useSendCommunicationModal();

  const [expandView, setExpandView] = useState<boolean>(false);
  const [expandDirection, setExpandDirection] = useState<string>('down');

  const handleChangeExpandView = () => {
    setExpandView((prev) => !prev);
    setExpandDirection(expandView ? 'down' : 'up');
  };

  const showAdditionalInfo =
    !data.isValidTestEmailRecipient && data.testEmailRecipient !== '';

  const isButtonDisabled =
    !data.isValidTestEmailRecipient ||
    !data.subject ||
    !data.body ||
    data.isLoading;

  return (
    <div className="test-email-section mt-3">
      <div className="d-flex align-items-center mb-2">
        <em className="icon ni ni-send mr-1" />
        <h6 className="my-0 mr-2">{t('SendTestEmail')}</h6>

        <button
          type="button"
          className="badge btn-primary"
          onClick={handleChangeExpandView}
        >
          <em className={`icon ni ni-chevron-${expandDirection}`} />
        </button>
      </div>

      {expandView && (
        <div className="row">
          <div className="col-6">
            <InputText
              id="email"
              placeholder={t('Email')}
              value={data.testEmailRecipient}
              onChange={actions.handleChangeTestEmailRecipient}
              additionalInfo={showAdditionalInfo ? t('InvalidEmail') : ''}
              additionalInfoType={
                showAdditionalInfo ? MessageType.ERROR : undefined
              }
              emailInput
            />
          </div>
          <div className="col-6 d-flex justify-content-end">
            <Button
              onClick={actions.handleSendTestEmail}
              disabled={isButtonDisabled}
              icon="ni ni-send"
              outlineStyle
            >
              {t('Send')}
            </Button>
          </div>
        </div>
      )}
    </div>
  );
};

export default TestEmailSection;
